import React from "react";
import { Button } from "../../common/commonIndex";
import { useNavigate, useSearchParams } from "react-router-dom";
import CloseIcon from '../../assets/images/doctorProfile/close-icon.svg';
import { Image } from "components/componentIndex";

const SuccessPage = ({ handleNextEvent, successMsgData, isCallUS, deniedObj }) => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const handleSubmit = () => {
        localStorage.removeItem('listOfAnswer');
        navigate('/visits');
        localStorage.removeItem('skippedQuestionIndex');
    }

    const handleBack = () => {
        handleSubmit();
    }

    return (
        <>
            {isCallUS ? (
                <>
                    <div className="d-flex justify-content-between align-item-center questionnaire-message-header">
                        <div onClick={handleBack} className='px-3 cursor-pointer'>
                            <Image imgUrl={CloseIcon} altText={"Left Chevron"} className={'cancle-questionnaire'} />
                        </div>
                        <h4 className="main-title mb-0">{deniedObj.mainTitle}</h4>
                        <div></div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center call-us-screen">
                        <div className="questionnaire-success mt-1 mt-md-5">
                            <div className="success-bg questionnaire" style={{
                                backgroundImage: `url(${deniedObj.img})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat'
                            }} ></div>
                            <div className="">
                                <h4 className="title">{deniedObj.title}</h4>
                                <p className="message ">{deniedObj.message}</p>
                                <Button btnType={deniedObj.btnType} btnClass={deniedObj.btnClassName} btnName={deniedObj.btnName} isDisabled={deniedObj.isDisabled} onClick={handleSubmit} />
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="d-flex justify-content-between align-item-center questionnaire-message-header">
                        <div onClick={handleBack} className='px-3 cursor-pointer'>
                            <Image imgUrl={CloseIcon} altText={"Left Chevron"} className={'cancle-questionnaire'} />
                        </div>
                        <h4 className="main-title mb-0">{successMsgData.mainTitle}</h4>
                        <div></div>
                    </div>

                    <div className="d-flex justify-content-center align-items-center">
                        <div className="questionnaire-success mt-1 mt-md-5">
                            <div className="success-bg questionnaire" style={{
                                backgroundImage: `url(${successMsgData.img})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat'
                            }} ></div>
                            <div className="">
                                <h4 className="title">{successMsgData.title}</h4>
                                <p className="message">{successMsgData.message}</p>
                                <Button btnType={successMsgData.btnType} btnClass={successMsgData.btnClassName} btnName={successMsgData.btnName} isDisabled={successMsgData.isDisabled} onClick={handleSubmit} />
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default SuccessPage;